import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { ReactComponent as PhaseIcon } from '../../../assets/icons/phase-icon.svg';
import { ReactComponent as SubphaseIcon } from '../../../assets/icons/subphase-icon.svg';
import { ReactComponent as TaskIcon } from '../../../assets/icons/task-icon.svg';
import { SimpleNode } from '../../../models/models';
import { selectNodeSelected } from '../../../store/node/node.selector';
import {
    getNodeTypeLabel,
    getRefusedAttachmentsLabel,
} from '../../../utils/data/data.utils';
import {
    CustomAccordionSummary,
    CustomAccordionSummaryIcon,
    CustomAccordionSummaryText,
} from './node-accordion-summary.styles';

const NodeAccordionSummary = ({ node }: { node: SimpleNode }) => {
    const nodeSelected = useSelector(selectNodeSelected);

    return (
        <CustomAccordionSummary>
            <Box
                display={'flex'}
                gap={2}
                alignItems={'center'}
                width={'25%'}
                pr={2}
            >
                <CustomAccordionSummaryIcon>
                    {node.type === 'phase' && <PhaseIcon />}
                    {node.type === 'subphase' && <SubphaseIcon />}
                    {node.type === 'task' && <TaskIcon />}
                </CustomAccordionSummaryIcon>
                <CustomAccordionSummaryText>
                    {getNodeTypeLabel(node.type)} {node.status.label}
                </CustomAccordionSummaryText>
            </Box>
            <Box width={'30%'} pr={2}>
                <CustomAccordionSummaryText>
                    {node.name}
                </CustomAccordionSummaryText>
            </Box>
            <Box width={'20%'} pr={2}>
                <CustomAccordionSummaryText>
                    {node.project.name}
                </CustomAccordionSummaryText>
            </Box>
            <Box width={'25%'}>
                <CustomAccordionSummaryText
                    textAlign={'right'}
                    color={
                        node.refused_attachments_count > 0 ? 'error' : 'default'
                    }
                >
                    {getRefusedAttachmentsLabel(
                        nodeSelected && nodeSelected.id === node.id
                            ? nodeSelected.refused_attachments_count
                            : node.refused_attachments_count
                    )}
                </CustomAccordionSummaryText>
            </Box>
        </CustomAccordionSummary>
    );
};

export default NodeAccordionSummary;
